function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { registerDestructor } from "@ember/destroyable";
import Modifier from "ember-modifier";
import $ from "jquery";
import "../vendor/transition.min.js";
export default class FuiModuleModifier extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "jqueryObject", void 0);
    _defineProperty(this, "semanticModuleName", void 0);
    registerDestructor(this, () => this.semanticModule("destroy"));
  }
  get settings() {
    return {};
  }
  get semanticModule() {
    return this.jqueryObject[this.semanticModuleName].bind(this.jqueryObject);
  }
  settingExistsOnModule(setting) {
    return Object.keys(this.jqueryObject[this.semanticModuleName].settings).includes(setting);
  }
  modify(element, positional, named) {
    if (this.jqueryObject) return;
    this.jqueryObject = $(element);
    const settings = this.settings;
    if (!this.semanticModuleName) this.semanticModuleName = positional[0];
    let lastPositionalArg;
    if (positional.length > 0) lastPositionalArg = positional[positional.length - 1];
    const settingArgs = typeof lastPositionalArg === "object" ? lastPositionalArg : named;
    Object.entries(settingArgs).forEach(([setting, value]) => {
      if (this.settingExistsOnModule(setting)) settings[setting] = value;
    });
    this.semanticModule(settings);
  }
}